import React, { useContext } from 'react';
import { CommentsContext } from '../../../context/CommentsContext';
import Single from '../single';
import style from './style.module.scss';

import { comments_tr } from '../../../lang/comments';

function List() {
  const { list } = useContext(CommentsContext);

  return list && list.length ? (
    <div className={style.list}>
      {list.map((item, idx) => {
        return (
          <div key={idx}>
            <Single value={item} />
          </div>
        );
      })}
    </div>
  ) : (
    <p className={style.noComments}>{comments_tr().no_results}</p>
  );
}

export default List;
